import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import emailjs from 'emailjs-com';
import styles from './SharedFormPage.module.css';

const ContactPage = () => {
  const form = useRef();
  const navigate = useNavigate();
  const [messageStatus, setMessageStatus] = useState(''); // State to hold message status

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_wwi1bvt', 'template_9c4idb8', form.current, 'JTUPpUqzXBfH_B-D0')
      .then(
        (result) => {
          //console.log('Message sent!', result.text);
          setMessageStatus('Message sent successfully!'); // Update status message on success
        },
        (error) => {
          //console.log('Failed to send message', error.text);
          setMessageStatus('Failed to send message. Please try again.'); // Update status message on failure
        }
      );

    e.target.reset(); // Reset form after submission
  };

  return (
    <div className={styles.formPageContainer}>
      <div className={styles.formPageHeader}>
        <button 
          onClick={() => navigate('/')} 
          className={styles.formPageBackButton}
        >
          ← Back to Home
        </button>
        <button 
          onClick={() => navigate('/')} 
          className={styles.formPageCloseButton}
        >
          ×
        </button>
      </div>
      <h2 className={styles.formPageTitle}>Contact Us</h2>
      <form ref={form} onSubmit={handleSubmit} className={styles.formPageForm}>
                <div className={styles.formPageField}>
          <label className={styles.formPageLabel}>Work Email*</label>
          <input type="email" name="user_email" required className={styles.formPageInput} />
        </div>
        <div className={styles.formPageField}>
          <label className={styles.formPageLabel}>First Name*</label>
          <input type="text" name="first_name" required className={styles.formPageInput} />
        </div>
        <div className={styles.formPageField}>
          <label className={styles.formPageLabel}>Last Name*</label>
          <input type="text" name="last_name" required className={styles.formPageInput} />
        </div>
        <div className={styles.formPageField}>
          <label className={styles.formPageLabel}>Company Name</label>
          <input type="text" name="company_name" className={styles.formPageInput} />
        </div>
        <div className={styles.formPageField}>
          <label className={styles.formPageLabel}>Message*</label>
          <textarea name="message" required className={styles.formPageTextarea}></textarea>
        </div>
        <button type="submit" className={styles.formPageButton}>Send Message</button>
      </form>
      {messageStatus && <p className={styles.formPageStatusMessage}>{messageStatus}</p>}
    </div>
  );
};

export default ContactPage;
